import { render, staticRenderFns } from "./AboutSupplier.vue?vue&type=template&id=049dd656&scoped=true"
import script from "./AboutSupplier.vue?vue&type=script&lang=js"
export * from "./AboutSupplier.vue?vue&type=script&lang=js"
import style0 from "./AboutSupplier.vue?vue&type=style&index=0&id=049dd656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049dd656",
  null
  
)

export default component.exports